<template>
  <img :src="avatarUrl ?? '/default_avatar.png'" class="ctw-rounded-full ctw-w-8">
</template>

<script setup>
import { defineProps } from 'vue';

defineProps(['avatarUrl'])

</script>